<template>
  <div>
    <div v-if="isLoading" style="height: 50vh;">
      <v-container fill-height fluid>
        <v-row align="center" justify="center" class="text-center">
            <v-col>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-else>
      <v-container fill-height fluid>
        <v-row>
          <v-col cols="12" sm="4" offset-sm="4">
            <app-alert-error v-if="error" @dismissed="onDismiss" :text="error.message"></app-alert-error>
            <v-card>
              <v-card-actions>
                <v-btn block large color="primary" @click="resendConfirmationLink">Resend the confirmation link</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
         </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import { store } from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'Action',

  data() {
    return {
      isLoading: true
    }
  },

  computed: {
    ...mapGetters(['error'])
  },

  mounted() {
    const query = router.currentRoute.query

    switch (query.mode) {
      case 'verifyEmail':
        store.dispatch('handleVerifyEmail', query)
        break
      case 'resetPassword':
        store.dispatch('handleResetPassword', query.oobCode)
          .then(() => {
            this.isLoading = false
            router.push('/set-new-password')
          })
          .catch(error => {
            this.isLoading = false
            store.commit('setError', error)
          })
        break
      default:
        this.isLoading = false
        store.commit('setError', { message: 'Something went wrong, please try again.' })
    }
  },
  methods: {
    resendConfirmationLink() {
      store.commit('clearError')
      this.goToPath('reset-password')
    }
  }
}
</script>
